import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTextBubble = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M8 14.167a6.167 6.167 0 1 0-5.657-3.708c.105.24.132.51.055.76l-.517 1.675a1 1 0 0 0 1.234 1.255l1.77-.514c.24-.07.498-.044.729.053.734.308 1.54.479 2.386.479"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		stroke: "currentColor",
		strokeLinecap: "square",
		strokeWidth: .5,
		d: "M4.417 7.833a.583.583 0 1 0 1.166 0 .583.583 0 0 0-1.166 0Zm3 0a.583.583 0 1 0 1.166 0 .583.583 0 0 0-1.166 0Zm3 0a.583.583 0 1 0 1.166 0 .583.583 0 0 0-1.166 0Z"
	})]
});
export default SvgTextBubble;
